import React from 'react'
import { FormattedMessage } from "react-intl"
import { formatPrice } from '../utils'


const RiepilogoReport = ({ iva }) => {
  const price = 15000;
  return (
    <div className="row">
      <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
        <div className="summary-table">
          <div className="summary-table__head">
            <div className="row">
              <div className="col-md-4 col-sm-6 col-5">
                <h2><FormattedMessage id="report-acquisto" /></h2>
              </div>
              <div className="col-md-2 col-sm-3 col-3 text-center">
                <h4><FormattedMessage id="quantita" /></h4>
              </div>
              <div className="col-md-2 offset-md-1 col-sm-3 col-4 text-center">
                <h4><FormattedMessage id="price" /></h4>
              </div>
            </div>
          </div>
          <div className="summary-table__row">
            <div className="row" >
              <div className="col-md-4 col-sm-6 col-5">
                <h4><FormattedMessage id="report-iic-2020" /></h4>
              </div>
              <div className="col-md-2 col-sm-3 col-3 text-center">
                <h4>1</h4>
              </div>
              <div className="col-md-2 offset-md-1 col-sm-3 col-4 text-center">
                <h4>{formatPrice(price, 'EUR')}</h4>
              </div>
            </div>
          </div>
          {iva === 'true' && (
            <div className="summary-table__row">
              <div className="row">
                <div className="col-md-4 col-sm-6 col-5">
                  <h4><FormattedMessage id="iva" /></h4>
                </div>
                <div className="col-md-2 offset-md-3 col-sm-3 offset-sm-3 offset-3 col-4 text-center">
                  <h4>{formatPrice(price * 0.22, 'EUR')}</h4>
                </div>
              </div>
            </div>
          )}
          <div className="summary-table__row">
            <div className="row">
              <div className="col-md-4 col-sm-6 col-6">
                <h4><FormattedMessage id="totale" /></h4>
              </div>
              <div className="col-md-2 offset-md-3 col-sm-3 offset-sm-3 offset-2 col-4 text-center">
                <h4>{formatPrice(price * (iva === 'true' ? 1.22 : 1), 'EUR')}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default RiepilogoReport;